<template>
  <div>
    <!-- 解决方案 -->
    <div class="solution">
      <!-- 标题 -->
      <div class="solution-title">
        <div>
          <img src="../assets/img/home/three.png" alt="" />
        </div>
        <div style="margin-left:50px">
          {{ inputName }}
        </div>
        <div style="margin-left:50px">
          <img src="../assets/img/home/three.png" alt="" />
        </div>
      </div>
      <!-- form表单 -->
      <div class="solution-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="agriculturalFeedbackForm"
          label-width="200px"
        >
          <el-form-item label="姓名" prop="userName">
            <el-input
              v-model="agriculturalFeedbackForm.userName"
              placeholder="请输入您的姓名或称呼"
              class="input"
              @input="change"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="contact">
            <el-input
              v-model="agriculturalFeedbackForm.contact"
              placeholder="请输入您的联系方式"
              class="input"
              @input="change"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="content">
            <el-input
              v-model="agriculturalFeedbackForm.content"
              placeholder="请输入备注信息"
              class="input"
              @input="change"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div class="forward" @click="submit">
              立即预约
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['inputName', 'type'],
  data() {
    return {
      // 规则
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ]
      },
      // 申请入参
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: this.type // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      }
    }
  },
  created() {},
  computed: {
    // type
    normalizedSize: function() {
      return this.type.trim().toLowerCase()
    }
  },
  methods: {
    change() {
      this.$forceUpdate()
    },
    // 提交申请
    async submit() {
      // 验证表单是否合理
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        // 验证通过，进行下一步操作
        // type转为整型
        this.agriculturalFeedbackForm.source = parseInt(
          this.agriculturalFeedbackForm.source
        )
        const { data: res } = await this.$http.post(
          '/api/v1/user/agriculturalFeedback',
          this.agriculturalFeedbackForm
        )
        // console.log(response)
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }
        this.$message.success('预约成功')
        // 清空列表
        this.agriculturalFeedbackForm.userName = ''
        this.agriculturalFeedbackForm.content = ''
        this.agriculturalFeedbackForm.contact = ''
        this.backTop()
      })
    },
    // 回到顶部
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="less" scoped>
// 解决方案
.solution {
  background-color: #fff;
  height: 500px;
  margin: 0 auto;
  .solution-title {
    margin: 0 auto;
    height: 160px;
    line-height: 160px;
    width: 550px;
    display: flex;
    color: #333;
    font-size: 40px;
  }
  .solution-form {
    margin: 40px auto;
    width: 900px;
    .input {
      width: 500px;
    }
    .forward {
      margin: 20px auto 0 90px;
      width: 300px;
      height: 40px;
      line-height: 40px;
      background-color: orange;
      color: #fff;
      text-align: center;
      border-radius: 40px;
      cursor: pointer;
    }
  }
}
</style>
